import React, { useState } from 'react';
import './App.scss';
import StartScreen from './components/StartScreen/StartScreen';
import GameScreen from './components/GameScreen/GameScreen';
import ResultScreen from './components/ResultScreen/ResultScreen';
import MagicCursor from './components/MagicCursor/MagicCursor';

export type GameState = 'start' | 'playing' | 'won';

function App() {
  const [gameState, setGameState] = useState<GameState>('start');
  const [foundItems, setFoundItems] = useState<string[]>([]);
  const [gameKey, setGameKey] = useState(0); // Key to force GameScreen remount

  const handleStartGame = () => {
    setGameState('playing');
    setFoundItems([]);
    setGameKey(prev => prev + 1); // Force remount
  };

  const handleGameWon = (items: string[]) => {
    setFoundItems(items);
    setGameState('won');
  };

  const handleTryAgain = () => {
    setGameState('playing');
    setFoundItems([]);
    setGameKey(prev => prev + 1); // Force remount
  };

  const handleBackToStart = () => {
    setGameState('start');
    setFoundItems([]);
  };

  return (
    <div className="App">
      <MagicCursor />
      {gameState === 'start' && <StartScreen onStart={handleStartGame} />}
      {(gameState === 'playing' || gameState === 'won') && (
        <GameScreen isWon={gameState === 'won'} key={gameKey} onWin={handleGameWon} onTryAgain={handleTryAgain} />
      )}
      {gameState === 'won' && (
        <ResultScreen
          isWon={true}
          foundItems={foundItems}
          onTryAgain={handleTryAgain}
          onBackToStart={handleBackToStart}
        />
      )}
    </div>
  );
}

export default App;
